import React, { useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import "./Fonts.css";
import "./App.css";

import { CheckoutComicPage } from "./layouts/CheckoutComicPage/CheckoutComicPage";
import { Footer } from "./layouts/HomePage/nav/Footer";
import { Navbar } from "./layouts/HomePage/nav/Navbar";
import { HomePage } from "./layouts/HomePage/HomePage";
import { SearchComicPage } from "./layouts/SearchComicsPage/SearchComicsPage";

import { config } from "./Constants";
import { Login } from "./layouts/Auth/Login";
import { SignUp } from "./layouts/Auth/SignUp";
import { Logout } from "./layouts/Auth/Logout";

import { Account } from "./layouts/User/Account";
import Status from "./layouts/User/Status";
import { LoadingSpinner } from "./layouts/utils/LoadingSpinner";
import { SpecialPage } from "./layouts/Auth/SpecialPage";
import PrivateRoute from "./layouts/Auth/PrivateRoute";



//import { Amplify } from "aws-amplify";

/*Amplify.configure({
	aws_cognito_region: COGNITO.REGION,
	aws_user_pools_id: COGNITO.USER_POOL_ID,
	aws_user_pools_web_client_id: COGNITO.APP_CLIENT_ID,
});*/

function App() {
	return (
		<Account>
			{/*<Status></Status>*/}
			<div className="d-flex flex-column min-vh-100">
				<Navbar />

				<div className="flex-grow-1">
					<Switch>
						<Route path="/" exact>
							<HomePage></HomePage>
						</Route>

						<Route path="/home">
							<Redirect to="/"></Redirect>
						</Route>

						<Route path="/search">
							<SearchComicPage></SearchComicPage>
						</Route>

						<Route path="/checkout/:comicId">
							<CheckoutComicPage></CheckoutComicPage>
						</Route>

	<Route path="/account"></Route>

						<Route path="/login">
							<Login></Login>
						</Route>

						<Route path="/signup">
							<SignUp></SignUp>
						</Route>

						<Route path="/logout">
							<Logout></Logout>
						</Route>

						<PrivateRoute path="/special">
							<SpecialPage></SpecialPage>
						</PrivateRoute>
					</Switch>
				</div>
				<Footer></Footer>
			</div>
		</Account>
	);
}

export default App;
